import { createPostEndpoint } from '@sonar-software/sonar-http';

export type PostUnfollowRequest = {
	sonarObjectIds: Array<number>;
};

export const postUnfollow = createPostEndpoint<PostUnfollowRequest>('/api/v3/core/followers/unfollow');
